Service Connection: <span [ngClass]="connectionStatus?.color">{{ connectionStatus.text }}</span>
